import Vue from 'vue'
import VueGtm from 'vue-gtm'
import VueAnalytics from 'vue-analytics'
import App from './App.vue'
import axios from 'axios'
import router from './router'
import store from './store'
import vueScrollto from 'vue-scrollto'
import VueYouTubeEmbed from 'vue-youtube-embed'
import Icon from './components/Icon'
import AOS from 'aos'
import 'aos/dist/aos.css'

Vue.prototype.$axios = axios

Vue.component('icon', Icon)

Vue.use(vueScrollto)
Vue.use(VueYouTubeEmbed)

Vue.use(VueGtm, {
  id: 'GTM-M8P8JM8',
  enabled: true,
  debug: true,
  vueRouter: router
})

Vue.use(VueAnalytics, {
  id: 'UA-31346950-6',
  router
})

Vue.config.productionTip = false

const app = new Vue({
  created () {
    AOS.init()
  },
  router,
  store,
  render: h => h(App)
})

router.onReady(() => {
  app.$mount("#app");
})
